<template>
  <div class="dashboard">
    <header-spotlight>
      <div class="group">
        <input type="search"
               class="terms"
               name="terms"
               :value="terms"
               v-on:keyup.enter="updateTerms"
               ref="inputTerms"
               placeholder="Código"
               required/>
        <button @click.prevent="updateTerms" class="search-button active">
          <img :src="require('@/assets/images/search.svg')" />
        </button>
      </div>
      <div v-if="terms" class="group">
        <button @click.prevent="clearTerms" class="active">Limpar</button>
      </div>
    </header-spotlight>
    <ul class="properties-list">
      <ListProperty
        v-for="property in properties"
        :key="property.id"
        :property="property"
      ></ListProperty>
    </ul>
    <router-view />
  </div>
</template>

<script>
import ListProperty from '@/components/ListProperty.vue';
import HeaderSpotlight from '@/components/HeaderSpotlight.vue';

export default {
  name: 'Dashboard',
  components: {
    ListProperty,
    HeaderSpotlight,
  },
  beforeCreate() {
    this.$store.commit('headerModeAuth', false);
    this.$store.commit('headerBack', false);
    this.$store.commit('headerSearch', false);
    this.$store.commit('headerUpdate', false);
  },
  computed: {
    terms() {
      return this.$store.state.terms;
    },
    properties() {
      const {
        properties,
        terms,
      } = this.$store.state;
      if (!terms) return [];
      let result = properties.filter((property) => property.code.toString() === terms);
      if (result.length) return result;

      result = properties.filter(
        (property) => property.searchText.indexOf(this.prepareSearch(terms)) >= 0,
      );

      return result;
    },
  },
  methods: {
    clearTerms() {
      const { inputTerms } = this.$refs;
      this.$store.commit('updateTerms', '');
      inputTerms.focus();
    },
    prepareSearch(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    },
    updateTerms(event) {
      const { inputTerms } = this.$refs;
      this.$store.commit('updateTerms', inputTerms.value);
      event.target.blur();
    },
  },
};
</script>

<style scoped>
  .dashboard{
    width: 100%;
    flex: 1;
    overflow: hidden;
    display: inline-flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: flex-start;
  }
  .terms{
    display: block;
    width: 100%;
    height: 40px;
    border-radius: 20px 0 0 20px;
  }
  .group{
    display: flex;
    width: 300px;
    min-height: 40px;
    justify-content: space-between;
  }
  .group.group-center{
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .group.group-vertical{
    flex-direction: column !important;
    padding: 5px;
    color: white;
  }
  .group button{
    width: auto;
    height: 25px;
    font-size: .8rem;
    padding: 2px 15px !important;
    background: transparent;
    border: 1px solid white;
    color: white;
    font-weight: bold;
    opacity: .4;
    margin: 2px;
  }
  .group button.active{
    background: white;
    color: var(--color-secondary-dark);
    opacity: 1;
  }
  .group button.search-button{
    width: 60px;
    height: 40px;
    border-radius: 0 20px 20px 0;
    background-color: var(--color-primary-dark);
    border-color: var(--color-primary-dark);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 5px;
    margin: 10px 0;
  }
  .group button.search-button img{
    display: block;
    width: 28px;
    height: 28px;
    object-fit: contain;
    object-position: center center;
  }
</style>
